// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"checkbox_checkboxContainer__ZURMC","checkRoundStyle":"checkbox_checkRoundStyle__ocFSp","inactiveCheckRoundStyle":"checkbox_inactiveCheckRoundStyle__6Zl5y"};